
<template>
  <div
    :class="['banner', {
      'banner--codigos': typePortal === 'codigos',
    }]"
  >
    <div
      v-if="typePortal === 'verano-joven'"
      class="banner__layer banner__layer--layer1"
    />
    <div
      :class="['banner__layer banner__layer--layer2', {
        'banner__layer banner__layer--layer2-codigos': typePortal === 'codigos',
      }]"
    >
      <img
        v-if="!isLoadingLayer1"
        :src="image1"
        :alt="getAltCentralImage()"
      />
    </div>
    <div
      v-if="typePortal === 'verano-joven'"
      class="banner__layer banner__layer--layer3"
    >
      <img
        v-if="!isLoadingLayer2"
        :src="image2"
        alt="Grupo de turistas fotografiando un paisaje"
      />
    </div>
  </div>
</template>

<script setup>
/* eslint-disable max-len */

// #region VUE
import {ref} from 'vue';
import {useImage} from '@vueuse/core';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const typePortal = ref(STTEDRA_TYPE_PORTAL);
const offlineYear = STTEDRA_OFFLINE_YEAR;
const image1 = require(`@/assets/images/${typePortal.value}/banner-portal-layer-1.png`);
const image2 = require(`@/assets/images/${typePortal.value}/banner-portal-layer-2.png`);
const {isLoading: isLoadingLayer1} = useImage({src: image1});
const {isLoading: isLoadingLayer2} = useImage({src: image2});
// #endregion

// #region Functions
const getAltCentralImage = () => {
  switch (typePortal.value) {
    case 'verano-joven':
      return `Descuentos en el Transporte Público, Verano joven ${offlineYear}, donde aparecen 3 maletas rotuladas con los textos Interrail, Bus y Tren`;
    case 'codigos':
      return 'Descuentos en el Transporte Público, donde aparecen 4 iconos de Tren, Bicibleta, Bus y Alta velocidad';
    default:
      return '';
  }
};
// #endregion

</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.banner{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  height: $pv__dm__banner--default;
  &--codigos{
    height: $pv__dm__banner--codigos;
  }
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 100vw;

  @include media("<=phone") {
    // background: transparent url('~@/assets/images/banner-portal-mobile.png');
    background: transparent var(--url-banner-phone);
    background-size: contain;
    background-repeat: no-repeat;
    height: $pv__dm__banner--phone;
    &__layer{
      display: none !important;
    }
  }

  @include media(">phone") {
    background: transparent var(--url-banner);
    background-position-y: bottom;
    &--codigos{
      background-position-y: center;
    }
  }

  &__layer{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
    height: 100%;

    & img{
      height: 100%;
      @include media("<=phone") {
        display: none;
      }
    }
  }

  &__layer--layer2{
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;

    & img {
      // background: $pv__color--white;
      // border: 7px solid $pv__color--green-banner;
      // padding: $brand__boxspace--medium;
      height: 70%;
      border-radius: 1.3rem !important;

      @include media("<=phone") {
        display: none;
      }
      @include media("<=tablet") {
        height: 30%;
      }
      @include media("<=desktop") {
        height: 50%;
      }
    }
  }

  &__layer--layer2-codigos{
    & img {
      height: 40%;

      @include media("<=tablet") {
        height: 30%;
      }

      @include media("<=desktop") {
        height: 50%;
      }
    }
  }

  &__layer--layer3{
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    & img {
      @include media("<=phone") {
        display: none;
      }
      @include media("<=tablet") {
        height: 50%;
      }
      @include media("<=desktop") {
        height: 70%;
      }
    }
  }
}
</style>
